import clsx, { type ClassValue } from 'clsx';

/** Merge conditional class names. Prefer over string concatenation in UI components. */
export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs);
}
